import React, { useState,useEffect} from 'react';
import Heading from '../../Components/Heading/heading.tsx';
import '../../Components/Button/button-style.scss';
import { Dialog, DialogActions, DialogContent, Button, TextField, SelectChangeEvent, Box, Chip, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import Dropdown from '../../Components/DropDown/drop-down.tsx';
import DatePicker from '../../Components/DatePicker/date-picker.tsx';
import { getDriverName, getOwnerName, addVehicle,editVehicle, addOwner,addOwnerDetails,addWarehouseUserMapping,getWarehouseUserMapping,deleteUserWarehousemapping,getVehicle,verifyOTP,getWarehouseCompanyMapping } from './action.ts';
import { toast, ToastContentProps } from 'react-toastify';
import AddDocumentModal from './add-document-modal.tsx';
import ConfirmationModal from './confirmation-modal.tsx';
import { validatePhoneNumber } from '../../Utils/PhoneNumberValidation/phone-number-validation.tsx';
import { formatVehicleNo } from '../../Utils/VehicleNumberValidation/vehicle-number-validation.tsx';
import OTPVerificationModal from './otp-verification-modal.tsx';
import AddOwnerModal from './add-owner-modal.tsx';
import CancelIcon from '@mui/icons-material/Cancel';


interface AddVehicleModalProps {
  addVehicleModalOpen: boolean;
  handleCloseAddVehicle: () => void;
  onRefreshVehicles?: () => void;
}

interface Warehouse {
  id: number;
  name: string;
}

interface Vendor {
  id: number;
  name: string;
}

const AddVehicleModal = ({ addVehicleModalOpen, handleCloseAddVehicle, onRefreshVehicles }: AddVehicleModalProps) => {
  const [selectedValue, setSelectedValue] = useState<{ [key: string]: string }>({
    numberPlate: '',
    model: '',
    regDate: '',
    fuelType:'',
  });
  const [isEditMode, setIsEditMode] = useState(false);
  const [isOTPModalOpen, setIsOTPModalOpen] = useState(false);
  const [errorWarehouse, setErrorWarehouse] = useState('');
  const [ownerPhoneNumber, setOwnerPhoneNumber] = useState<string>('');
  const [ownerPhoneError, setOwnerPhoneError] = useState<string>('');
  const [driverPhoneNumber, setDriverPhoneNumber] = useState<string>('');
  const [driverPhoneError, setDriverPhoneError] = useState<string>('');
  const [driverName, setDriverName] = useState<string>('');
  const [ownerName, setOwnerName] = useState<string>('');
  const [ownerId, setOwnerId] = useState(0);
  const [driverId, setDriverId] = useState<string>('');
  const [userId, setUserId] = useState(0);
  const [apiSucessForOwner, setApiSuccessForOwner] = useState<string>('');
  const [apiSucessForDriver, setApiSuccessForDriver] = useState<string>('');
  const [vendorName, setVendorName] = useState<string>('');
  const [warehouseData, setWarehouseData] = useState<Warehouse[]>([]);
  const [warehouses, setWarehouses] = useState<Warehouse[]>([]);
  const [warehouseId, setWarehouseId] = useState<{ user_warehouse_id: string;warehouse_id:string; label: string }[]>([]);
  const [vendors, setVendors] = useState<Vendor[]>([]);
  const [vehicleId, setVehicleId] = useState(0);
 const [selectedWarehouse, setSelectedWarehouse] = useState<{ id: string; label: string }[]>([]);
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [selectedAction, setSelectedAction] = useState<string>('');
  const [isVehicleInactive, setIsVehicleInactive] = useState(false);
  const [driver, setDriver] = useState('');
  const [error, setError] = useState({
    numberPlate: '',
    regDate: '',
    model: '',
    fuelType:''
  });
  const [isFocusedOwner, setIsFocusedOwner] = useState(false);
  const [isFocusedDriver, setIsFocusedDriver] = useState(false);
  const [isDocumentModalOpen, setIsDocumentModalOpen] = useState(false);
  const [isAddOwnerModalOpen, setIsAddOwnerModalOpen] = useState(false);
    const storedUserDetails = localStorage.getItem("userdetails");
  const userRole = storedUserDetails ? JSON.parse(storedUserDetails).role : null;
  const clientName = storedUserDetails ? JSON.parse(storedUserDetails).client_name : null;
  const maxDate = new Date(); 
   const userDetailsFromStorage = JSON.parse(localStorage.getItem("userdetails") || "null");

    const companiesId = userDetailsFromStorage?.companies_id || '';

    const [originalVehicleDetails, setOriginalVehicleDetails] = 
  useState({
    model: '',
    regDate: '',
    numberPlate: '',
    fuelType: '',
    driverId: '',
    ownerId: 0
  });
  const handleClose = () => {
    if (isOTPModalOpen) return;
    handleCloseAddVehicle();
    setIsDocumentModalOpen(false);
    resetAddVehiclePopup();

  };
let otpVerified = '';
let isOtpVerified =false;
let documentUploaded =false;
  const resetAddVehiclePopup = () => {
    setSelectedValue({
      fuelType: '',
      numberPlate: '',
      model: '',
      regDate: '',
    });
    setOwnerPhoneNumber('');
    setOwnerPhoneError('');
    setDriverPhoneNumber('');
    setDriverPhoneError('');
    setDriverName('');
    setOwnerName('');
    setOwnerId(0);
    setDriverId('');
    setUserId(0);
    setApiSuccessForOwner('');
    setApiSuccessForDriver('');
    setVendorName('');
    setWarehouses([]);
    setVendors([]);
    setSelectedWarehouse([]);
    setWarehouseData([]);
    setError({
      numberPlate: '',
      regDate: '',
      model: '',
      fuelType:'',
    });
    setIsFocusedOwner(false);
    setIsFocusedDriver(false);
    setErrorWarehouse('');
    setDriver('');
    setIsEditMode(false); 
  };
useEffect(() => {
  if (addVehicleModalOpen) {
    const storedUserDetails = localStorage.getItem("userdetails");
    const vendorName = storedUserDetails ? JSON.parse(storedUserDetails).vendor_name : null;
    const vendorId = storedUserDetails ? JSON.parse(storedUserDetails).vendor_id : 0;
    const clientName = storedUserDetails ? JSON.parse(storedUserDetails).client_name : null;
    const userRole = storedUserDetails ? JSON.parse(storedUserDetails).role : null;
        if (vendorName || userRole === 'client_supervisor' || userRole === 'client_manager' || userRole === 'client_company_admin') {
      if (vendorName) {
        setVendorName(vendorName);
      }
      
            getWarehouseCompanyMapping(
        companiesId,
        (response: any) => {
            const warehouses = response.user_warehouses.map((item: any) => item.warehouse);
            setWarehouses(warehouses);
        },
        (errMessage: any) => {
            toast.error(errMessage.message);
        }
    );
      
    }
  }
}, [addVehicleModalOpen]);
const handleCancel = () => {
  if (isOTPModalOpen) return;
  resetAddVehiclePopup();
  handleCloseAddVehicle();
};

  const fuelOptions = [
    { id: 'diesel', label: 'Diesel' },
    { id: '2W-EV', label: '2 Wheeler EV' },
    { id: '3W-EV', label: '3 Wheeler EV' },
    { id: 'petrol', label: 'Petrol' },
    { id: 'CNG', label: 'CNG' }
  ];
  const modelOptions = [
    { id: 'EV', label: 'EV' },
    { id: 'Tata Ace', label: 'Tata Ace' }
  ];
  const validateVehicleNo = (vehicleNo: string) => {
    if (!vehicleNo) {
      return "";
    }
    const replacedSpace = vehicleNo.replace(/ /g, "");
    const pattern = /^([A-Z]{2})(\d{2})([A-Z]{0,2})?(\d{1,4})?$/;
    const match = replacedSpace.match(pattern);
    let errorMessage = '';
    if (match) {
      const [, part1, part2, part3, part4] = match;
      if (part2 && (!part4 || part4.length === 0)) {
        errorMessage = 'Invalid vehicle number format';
      }
      if (part3 && part3.length > 0 && (!part4 || part4.length === 0)) {
        errorMessage = 'Invalid vehicle number format';
      }
    } else {
      errorMessage = 'Invalid vehicle number format.';
    }
    if (errorMessage) {
      setError((prevError) => ({
        ...prevError,
        numberPlate: errorMessage,
      }));
    } else {
      setError((prevError) => ({
        ...prevError,
        numberPlate: '',
      }));
    }
  };
  const resetFormFields = () => {
    setSelectedValue((prevValue) => ({
      ...prevValue,
      model: '',
      regDate: '',
      fuelType:'',
    }));
    setDriverName('');
    setDriverId('');
    setOwnerName('');
    setOwnerId(0);
    setDriverPhoneNumber('');
    setOwnerPhoneNumber('');
    setApiSuccessForDriver('false');
    setApiSuccessForOwner('false');
    setIsEditMode(false);
  };
  const handleInputChange = (event: { target: any; }) => {
    const { name, value } = event.target;
    setError((prevError) => ({
      ...prevError,
      [name]: '',
    }));
  
    if (name === 'numberPlate') {
      const { formatted, error } = formatVehicleNo(value);
      setSelectedValue((prevValue) => ({
        ...prevValue,
        [name]: formatted,
      }));
      setError((prevError) => ({
        ...prevError,
        numberPlate: error,
      }));
  
      if (formatted !== selectedValue.numberPlate) {
        setIsVehicleInactive(false); 
        resetFormFields();
      }
    } else {
      setSelectedValue((prevValue) => ({
        ...prevValue,
        [name]: value,
      }));
    }
  };
  const handlePhoneNumberChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = event.target;
    if (name === 'driverPhoneNumber') {
      setDriverPhoneNumber(value);
    }
    if (name === 'ownerPhoneNumber') {
      setOwnerPhoneNumber(value);
    }
    if (value === '') {
      if (name === 'ownerPhoneNumber') {
        setOwnerPhoneError("");
        setApiSuccessForOwner("false");
        setOwnerName("");
      }
      if (name === 'driverPhoneNumber') {
        setDriverPhoneError("");
        setApiSuccessForDriver("false");
        setErrorWarehouse("");
      }
      return;
    }
    const { errorMessage } = validatePhoneNumber(value);
    if (name === 'ownerPhoneNumber') {
      setOwnerPhoneError(errorMessage);
    } else if (name === 'driverPhoneNumber') {
      setDriverPhoneError(errorMessage);
      setSelectedWarehouse([{ id: '', label: 'Select Warehouse' }]);
      setErrorWarehouse("");
    }
  };

  const handleFocusOwner = () => {
    setIsFocusedOwner(true);
  };

  const handleBlurOwner = () => {
    if (ownerPhoneNumber.length >= 1 && ownerPhoneNumber.length < 10) {
      setOwnerPhoneError('Phone number must be 10 digits');
      setOwnerName('');
      setApiSuccessForOwner("false");
      setIsFocusedOwner(false);
    } else if (ownerPhoneNumber.length === 10) {
      setIsFocusedOwner(false);
      getOwnerName(ownerPhoneNumber,
        (response) => {
                    const user = response.message.vehicles_owners_list[0];
          const userName = user?.name || '';
          const userIdSuccess = Number(user?.id);
          setOwnerName(userName);
          setApiSuccessForOwner("true");
          setOwnerId(userIdSuccess);
        },
        (errorMessage) => {
          if (errorMessage.status === 404 || errorMessage.message === "No Client Found") {
            setIsAddOwnerModalOpen(true);
          } else {
            setApiSuccessForOwner("false");
            setOwnerPhoneError("User Not found");
            setOwnerName("");
          }
        }
      );
    } else {
      setIsFocusedOwner(false);
    }
  };

  const handleFocusDriver = () => {
    setIsFocusedDriver(true);
  };

 const handleBlurDriver = () => {
  if (driverPhoneNumber.length >= 1 && driverPhoneNumber.length < 10) {
    setDriverPhoneError('Phone number must be 10 digits');
    setDriverName('');
    setIsFocusedDriver(false);
    setDriver('');
    setApiSuccessForDriver("false");
    setErrorWarehouse("");
    setSelectedWarehouse([{ id: '', label: 'Select Warehouse' }]);
  } else if (driverPhoneNumber.length === 10) {
    setIsFocusedDriver(false);
    getDriverName(driverPhoneNumber,
      (success) => {
        setDriverPhoneError('');
        const user = success.message.user[0];
        const userName = user?.user_name || '';
        const userIdSuccess = user?.user_unique_id;    
        setDriverName(userName);
        setApiSuccessForDriver("true");
        setUserId(userIdSuccess);
        setDriverId(userIdSuccess);
        setDriver('');
        setSelectedWarehouse([]);
        setWarehouseData([]);
        getWarehouseUserMapping(
          userIdSuccess,
          (response) => { 
            const userWarehouses = response.user_warehouses.map((mapping: { warehouse: any; }) => mapping.warehouse);
            const mappingDetails = response.user_warehouses.map((mapping: { id: any; warehouse: { id: any; name: any; }; }) => ({
              user_warehouse_id: mapping.id,
              warehouse_id: mapping.warehouse.id,
              warehouse_name: mapping.warehouse.name
            }));
            setWarehouseData(userWarehouses);
            const initialSelected = userWarehouses.map((wh: { id: { toString: () => any; }; name: any; }) => ({
              id: wh.id.toString(),
              label: wh.name
            }));
            setSelectedWarehouse(initialSelected);
            setWarehouseId(mappingDetails);
          },
          (errorMessage) => { 
            setSelectedWarehouse([]);
            setWarehouseData([]);
            if (errorMessage.status !== 404) {
              toast.error(errorMessage); 
            }
          }
        );
      },
      (errorMessage) => {
        if (errorMessage.status === 400) {
          setApiSuccessForDriver("false");
          setDriverPhoneError(" User not found");
          setDriverName("");
          setDriver('1');
          setErrorWarehouse("");
        }
      }
    );
  } else {
    setIsFocusedDriver(false);
  }
};

const handleWarehouseSelectionChange = (event: SelectChangeEvent<string>) => {
  const selectedIds = event.target.value as unknown as string[];
  
  const removedWarehouses = selectedWarehouse.filter(
    wh => !selectedIds.includes(wh.id)
  );
  
  removedWarehouses.forEach(warehouse => {
    const mapping = warehouseId.find(
      wh => wh.warehouse_id.toString() === warehouse.id
    );
    if (mapping) {
      const userWarehouseId = mapping.user_warehouse_id;
      deleteUserWarehousemapping(
        userWarehouseId,
        (response) => {
          if (response.status === 200) {
            toast.success(`Warehouse ${warehouse.label} removed successfully`);
            setWarehouseData(prev => 
              prev.filter(wh => wh.id.toString() !== warehouse.id)
            );
            setSelectedWarehouse(prev =>
              prev.filter(wh => wh.id !== warehouse.id)
            );
          }
        },
        (error) => {
          toast.error(`Failed to remove warehouse ${warehouse.label}: ${error.message}`);
          setSelectedWarehouse(prev => [...prev, warehouse]);
        }
      );
    }
  });

  const newSelectedWarehouses = warehouses
    .filter(wh => selectedIds.includes(wh.id.toString()))
    .map(wh => ({
      id: wh.id.toString(),
      label: wh.name
    }));
  
  setSelectedWarehouse(newSelectedWarehouses);
  setErrorWarehouse('');
};
  const userWarehouseMapping = () => {
  if (selectedWarehouse.length > 0 && (userId || driverId)) {
    const currentWarehouseIds = warehouseData.map(wh => wh.id.toString());
    const warehousesToMap = selectedWarehouse.filter(
      wh => !currentWarehouseIds.includes(wh.id)
    );

    if (warehousesToMap.length === 0) {
      return;
    }

    const mappingPromises = warehousesToMap.map(warehouse => {
      const warehouseId = parseInt(warehouse.id, 10);
      return new Promise((resolve, reject) => {
        addWarehouseUserMapping(
          userId || driverId,
          warehouseId,
          (mappingResponse) => {
            if (mappingResponse.data.status === 200) {
              toast.error(mappingResponse?.data?.message);
              resolve({ success: false, message: mappingResponse?.data?.message });
            } else if (mappingResponse.data.status === 201) {
              toast.success(mappingResponse.data.message);
              handleClose();
              resolve({ success: true, message: mappingResponse.data.message });
            }
          },
          (errorMessage) => {
            if(errorMessage.status === 409){
              console.log(errorMessage.message)
            }
            else {
              toast.error(errorMessage.message);
              reject(errorMessage);
            }
          }
        );
      });
    });

    Promise.all(mappingPromises)
      .then(results => {
        console.log('New warehouse mappings completed', results);
      })
      .catch(error => {
        console.error('Error in warehouse mappings:', error);
      });
  }
};
  const handleVehicleNumberBlur = () => {
    const currentVehicleNumber = selectedValue.numberPlate;
    validateVehicleNo(currentVehicleNumber);
    if (!error.numberPlate && currentVehicleNumber) {
      getVehicle('','',
        (response)=>{
          if(response.status === 200){
            toast.error("Vehicle is in Inactive state. Activate from Inactive Tab.");  
            setIsVehicleInactive(true);
          }},
          (errorMessage)=>{console.log(errorMessage)},0,currentVehicleNumber,'')
      getVehicle(
        '',
        '',
        (response: any) => {
          const vehicleDetails = response.message?.vehicles_list || [];
          if (vehicleDetails.length > 0) {
            const vehicle = vehicleDetails[0];
                    getWarehouseUserMapping(
                                vehicle?.driver_id,
                                (response) => { 
                                  const userWarehouses = response.user_warehouses.map((mapping: { warehouse: any; }) => mapping.warehouse);
                                 const mappingDetails = response.user_warehouses.map((mapping: { id: any; warehouse: { id: any; name: any; }; }) => ({
                                    user_warehouse_id: mapping.id,
                                    warehouse_id:mapping.warehouse.id,
                                    warehouse_name:mapping.warehouse.name}));
                                  setWarehouseData(userWarehouses);
                                  const initialSelected = userWarehouses.map((wh: { id: { toString: () => any; }; name: any; }) => ({
                                    id: wh.id.toString(),
                                    label: wh.name
                                  }));
                                  setSelectedWarehouse(initialSelected);
                                  setWarehouseId(mappingDetails);
                                },
                                (errorMessage) => { toast.error(errorMessage); }
                              )
              if (vehicle.number_plate === currentVehicleNumber) {
              setSelectedValue({
                numberPlate: vehicle.number_plate,
                model: vehicle.make_model,
                regDate: vehicle.reg_date,
                fuelType:vehicle.fuel_type
              });
              setOriginalVehicleDetails({
                model: vehicle.make_model,
                regDate: vehicle.reg_date,
                numberPlate: vehicle.number_plate,
                fuelType: vehicle.fuel_type,
                driverId: vehicle.driver_id,
                ownerId: vehicle.owner_id || 0
              });
              setDriverName(vehicle.driver_name);
              setDriverId(vehicle.driver_id);
              setOwnerName(vehicle.owner_name || '');
              setOwnerId(vehicle.owner_id || 0);
              setDriverPhoneNumber(vehicle.driver_phone || '');
              setOwnerPhoneNumber(vehicle.owner_phone || '');
              setApiSuccessForDriver(vehicle.driver_name ? 'true' : 'false');
              setApiSuccessForOwner(vehicle.owner_name ? 'true' : 'false');
              setIsEditMode(true);
            }
          } else {
            setIsEditMode(false); 
          }
        },
        (errMessage: any) => {
          if (errMessage.message?.errors?.number_plate) {
            toast.error(errMessage.message?.errors?.number_plate[0]);
          } else {
            console.log(errMessage.message);
          }
          setIsEditMode(false);
        },
        1,
        currentVehicleNumber,
        '',
      );
    }
  };
const hasWarehouseChanged = () => {
  const currentWarehouseIds = warehouseData.map(wh => wh.id.toString());
  const selectedWarehouseIds = selectedWarehouse.map(wh => wh.id);
  
  const addedWarehouses = selectedWarehouseIds.filter(id => 
    !currentWarehouseIds.includes(id)
  );
  
  return addedWarehouses.length > 0;
};
const handleSubmit = () => {
  
  const { model, regDate, numberPlate, fuelType } = selectedValue;
  setDriverPhoneError('');
  setOwnerPhoneError('');
  setError((prevError) => ({
    ...prevError,
    numberPlate: !selectedValue.numberPlate ? 'Vehicle number is required' : '',
    model: !selectedValue.model ? 'Model is required' : '',
    regDate: !selectedValue.regDate ? 'Registration Date is required' : '',
    fuelType: !selectedValue.fuelType ? 'Fuel Type is required' : '',
  }));
  if (driver === '1') {
    setDriverPhoneError("User Not Found");
  }
  if (ownerPhoneNumber.length > 0 && ownerName === '') {
    toast.error("1");
    return;
  }
  if(ownerPhoneNumber === ''){
    setOwnerPhoneError("Owner is Mandatory");
  }
  if (driverId && (!selectedWarehouse[0] || !selectedWarehouse[0].id)) {
    setErrorWarehouse('Warehouse is mandatory');
    return; 
  }
  if (selectedWarehouse[0]?.id && !driverId) {
    setDriverPhoneError('Driver is mandatory');
    return;
  }
  if (isEditMode) {
    const payload: any = {
      numberPlate
    };
    
    if (selectedValue.model !== originalVehicleDetails.model) {
      payload.model = selectedValue.model;
    }
    
    if (selectedValue.regDate !== originalVehicleDetails.regDate) {
      payload.regDate = selectedValue.regDate;
    }
    
    if (selectedValue.fuelType !== originalVehicleDetails.fuelType) {
      payload.fuelType = selectedValue.fuelType;
    }
    
    if (driverId !== originalVehicleDetails.driverId) {
      payload.driverId = driverId;
    }
    
    if (ownerId !== originalVehicleDetails.ownerId) {
      payload.ownerId = ownerId;
    }

    if (Object.keys(payload).length === 1) { 
      if (hasWarehouseChanged()) {
        userWarehouseMapping();
      }
      if (isOtpVerified) {
        setTimeout(() => {
          handleClose();
        }, 1000);
      }

      return;
    }

    if (!payload.driverId && !hasWarehouseChanged()) {
      editVehicle(
        payload.model || '',
        payload.regDate || '',
        payload.numberPlate,
        '',
        payload.ownerId || undefined, 
        payload.fuelType || '',
        otpVerified,
        '',
        '',
        handleVehicleResponse,
        handleVehicleError
      );
      if (isOtpVerified) {
  setTimeout(() => {
    handleClose();
  }, 1000);
}

      return;
    }
    else {
    editVehicle(
      payload.model || '',
      payload.regDate || '',
      payload.numberPlate,
      payload.driverId || undefined,
      payload.ownerId || undefined,
      payload.fuelType || '',
      otpVerified,
      '',
      '',
      (response) => {
        handleVehicleResponse(response);
        if (hasWarehouseChanged()) {
          userWarehouseMapping();
        }
        if (isOtpVerified) {
  setTimeout(() => {
    handleClose();
  }, 1000);
}

      },
      handleVehicleError
    );
  }
  } else {
    if (error.numberPlate === '' && error.model === '' && error.regDate === '' && 
        ownerPhoneError === '' && driverPhoneError === '' && driver === '' ) {
      addVehicle(
        model,
        regDate,
        numberPlate,
        driverId,
        ownerId,
        fuelType,
        otpVerified,
        '',
        '',
        (response) => {
          handleVehicleResponse(response);
        },
        handleVehicleError
      );
      if (isOtpVerified && documentUploaded) {
   setTimeout(() => {
    handleClose();
  }, 1000);
}

    } else {
      toast.error("Please fix the errors2");
    }
  }
};
 

const handleVehicleResponse = (response: { status: number; data: { status: number; message: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | ((props: ToastContentProps<unknown>) => React.ReactNode) | null | undefined; }; message: { message: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | ((props: ToastContentProps<unknown>) => React.ReactNode) | null | undefined; }; }) => {
  if (response.status === 200) {
    if (response?.data?.status === 308) {
      toast.error(response.data.message);
    } else if (response?.data?.status === 400) {
      toast.error("Please contact your administrator");
    } else if (response?.data?.message === 'OTP sent.' ||
      response?.data?.message === 'Old OTP expired. New OTP generated and re-sent.' ||
      response?.data?.message === 'OTP re-sent.') {
      setIsOTPModalOpen(true);
   return;
    } else if (response.message.message === 'Driver updated successfully') {
      toast.success(response?.message?.message);    
      isOtpVerified=true;
 
    } else {
      toast.error(response?.message || 'An error occurred');
    }
  } else if (response.status === 201) {
    const id = response?.data?.message?.id;
     setVehicleId(id);
    isOtpVerified=true;
    userWarehouseMapping();
    setIsDocumentModalOpen(true);
   documentUploaded =false;
    toast.success(response?.data?.message?.message);
  }
};

const handleVehicleError = (errorMessage: { status: number; message: { error: string | number | boolean | React.ReactElement<any, string | React.JSXElementConstructor<any>> | Iterable<React.ReactNode> | ((props: ToastContentProps<unknown>) => React.ReactNode) | null | undefined; }; }) => {
  if(errorMessage.status === 400){
    if(errorMessage.message.error === "Confirmation required"){
      setIsConfirmationOpen(true);
      return;
    }
    else if (errorMessage.message.error === "Re-confirmation required"){
      setSelectedAction('reconfirm');
     setIsConfirmationOpen(true);
     return;
  }
}
  toast.error(errorMessage.message.error);
};

  const handleVerifyOTP = (otp: string): Promise<{ success: boolean; message?: string }> => {
    return new Promise((resolve, reject) => {
      verifyOTP(
        driverPhoneNumber,
        '91',
        otp,
        (response) => {
         
          if (response.data.status === 200) {
            toast.success(response.data.message);
            otpVerified = '1';
            isOtpVerified=true;
            setIsOTPModalOpen(false);
            resolve({ success: true });

            handleSubmit();
          } else {
           resolve({ success: false, message: response.data.message|| 'OTP verification failed.' });
          }
        },
        (errorMessage) => {
          resolve({ success: false, message: errorMessage });
        }
      );
    });
  };
  const handleConfirmationAction = (action: string) => {
    setIsConfirmationOpen(false);
    const driverSwitch = 
      action === '1' ? 1 :
      action === '2' ? 2 : 3;
       const switchReconfirm = action === '1'? 1 : '';
    if (selectedAction !== 'Cancel') {
      const vehicleAction = isEditMode ? editVehicle : addVehicle;
      vehicleAction(
        selectedValue.model,
        selectedValue.regDate,
        selectedValue.numberPlate,
        driverId,
        ownerId,
        selectedValue.fuelType,
        otpVerified,
        driverSwitch,
        switchReconfirm,
        (response) => {
          handleVehicleResponse(response);
          if (selectedWarehouse.length > 0 && selectedWarehouse[0]?.id) {
            userWarehouseMapping();
            if (isEditMode){
              if(isOtpVerified) {
              setTimeout(() => {
                handleClose();
              }, 1000);
            } else return;
          }
          else {
          if(isOtpVerified && documentUploaded) {
              setTimeout(() => {
                handleClose();
              }, 1000);
            } else return;
          }

          }
        },
        handleVehicleError,
      );
    }
  };
  

  const options = warehouses.map((warehouse) => ({
    id: warehouse.id.toString(),
    label: warehouse.name,
  }));


  const optionsVendor = vendors.map((vendor) => ({
    id: vendor.id.toString(),
    label: vendor.name,
  }));

  const handleModel = () => {
    if (error.model) {
      setError((prevError) => ({
        ...prevError,
        model: error.model,
      }));
    }
  };

  const handleMakeYearBlur = () => {
    if (error.regDate) {
      setError((prevError) => ({
        ...prevError,
        regDate: error.regDate,
      }));
    }
  };

  const handleAddOwner = (name: string, phoneNumber: string,email:any,address:any,ifsc:any,accountNumber:any,remarks:any) => {
   addOwner(name,phoneNumber,(response) => {
    toast.success('Owner added successfully ');
    setIsAddOwnerModalOpen(false)
    const ownerId = response.vehicle_owner.id;
    setOwnerId(ownerId);
 if(ownerId&&(ifsc || accountNumber || remarks || email || address)){
  addOwnerDetails(ownerId,accountNumber,ifsc,remarks,email,address,(response) => { toast.success('Owner added successfully ');},
  (errorMessage) => {
    toast.error(errorMessage);
  } );
 }
  },
  (errorMessage) => {
    toast.error(errorMessage);
  })
    setOwnerName(name);
    setApiSuccessForOwner("true");
    setOwnerPhoneNumber(phoneNumber);
  };

  return (
    <Dialog open={addVehicleModalOpen}
  onClose={isOTPModalOpen ? () => {} : handleCloseAddVehicle}
  disableEscapeKeyDown={isOTPModalOpen}>
        <Box
          sx={{
            marginLeft: {
              xs: '0px',
              sm: '-180px',
  
            },
          }}
        >
          <Heading title="Add Vehicle" closeIcon="true" onClose={handleCloseAddVehicle} />
        </Box>

      <DialogContent>
        <Box sx={{ marginLeft: { xs: '-10px', sm: '0px' }, marginTop: '5px' }}>
          <p style={{ fontSize: '17px' }}>Vehicle Number</p>
        </Box>
        <Box sx={{ marginLeft: { xs: '112px', sm: '200px' }, marginTop: '-22px' }}>
          <Box display="flex" alignItems="center">
            <TextField
              style={{ width: '225px' }}
              variant="outlined"
              size="small"
              name="numberPlate"
              placeholder="Eg: KA 23 DE 1234"
              value={selectedValue.numberPlate}
              onBlur={handleVehicleNumberBlur}
              onChange={handleInputChange}
              error={!!error.numberPlate}
              helperText={error.numberPlate}
            />
          </Box>
        </Box>
        <Box sx={{ marginLeft: { xs: '-10px', sm: '0px' }, marginTop: '5px' }}>        <p style={{ fontSize: '17px' }}>Model</p>
        </Box>
        <Box sx={{ marginLeft: { xs: '112px', sm: '200px' }, marginTop: '-22px' , marginBottom: error.model ? '20px' : '0'}}>
          <Box display="flex" alignItems="center">
            <Dropdown
              options={modelOptions}
              selectedValue={selectedValue.model}
              handleChange={(e) => handleInputChange({
                target: {
                  name: 'model',
                  value: e.target.value
                }
              })}
              placeholder="Select Model"
              width="225px"
              height="41px"
              displayEmpty={true}
              error={!!error.model}
              helperText={error.model}
            />
          </Box>
        </Box>
        <Box sx={{ marginLeft: { xs: '-10px', sm: '-8px' }, marginTop: '5px' }}>        <p style={{ fontSize: '17px' }}>Registration Date</p>
        </Box>
        <Box sx={{ marginLeft: { xs: '112px', sm: '200px' }, marginTop: '-22px', marginBottom: error.regDate ? '20px' : '0' }}>
          <Box display="flex" alignItems="center">
             <DatePicker
                                id="regDate"
                                name="regDate"
                                value={selectedValue.regDate}
                                onChange={(e) => handleInputChange({
                                  target: {
                                    name: 'regDate',
                                    value: e.target.value
                                  }
                                })}
                                maxDate={maxDate}
                                error={!!error.regDate}
                                helperText={error.regDate}
                                
                              />
          </Box>
        </Box>
        <Box sx={{ marginLeft: { xs: '-10px', sm: '0px' }, marginTop: '5px' }}>        <p style={{ fontSize: '17px' }}>Fuel Type</p>
        </Box>
        <Box sx={{ marginLeft: { xs: '112px', sm: '200px' }, marginTop: '-22px', marginBottom: error.fuelType ? '20px' : '0'  }}>
          <Box display="flex" alignItems="center">
            <Dropdown
              options={fuelOptions}
              selectedValue={selectedValue.fuelType}
              handleChange={(e) => handleInputChange({
                target: {
                  name: 'fuelType',
                  value: e.target.value
                }
              })}
              placeholder="Select Fuel"
              width="225px"
              height="41px"
              displayEmpty={true}
              error={!!error.fuelType}
              helperText={error.fuelType}
            />
          </Box>
        </Box>
        <Box sx={{ marginLeft: { xs: '-10px', sm: '0px' }, marginTop: '5px' }}>        <p style={{ fontSize: '17px' }}>Owner</p>
        </Box>
        <Box sx={{ marginLeft: { xs: '112px', sm: '200px' }, marginTop: '-22px' }}>
          <Box display="flex" alignItems="center">
            <TextField
              style={{ width: '225px' }}
              variant="outlined"
              size="small"
              type="text"
              name="ownerPhoneNumber"
              value={
                !isFocusedOwner &&
                ownerPhoneNumber.length === 10 &&
                apiSucessForOwner === 'true'
                  ? ownerName
                  : ownerPhoneNumber
              }
              placeholder={
                !isFocusedOwner &&
                ownerPhoneNumber.length === 10 &&
                apiSucessForOwner === 'true'
                  ? ''
                  : 'Phone Number'
              }
              onChange={(e) => handlePhoneNumberChange(e)}
              onFocus={handleFocusOwner}
              onBlur={handleBlurOwner}
              error={!!ownerPhoneError}
              helperText={ownerPhoneError}
            />
          </Box>
        </Box>
        <Box sx={{ marginLeft: { xs: '-10px', sm: '0px' }, marginTop: '5px' }}>        <p style={{ fontSize: '17px' }}>Driver</p>
        </Box>
        <Box sx={{ marginLeft: { xs: '112px', sm: '200px' }, marginTop: '-22px' }}>
          <Box display="flex" alignItems="center">
            <TextField
              variant="outlined"
              size="small"
              type="text"
              name="driverPhoneNumber"
              value={
                !isFocusedDriver && driverPhoneNumber.length === 10 && apiSucessForDriver === 'true'
                  ? driverName
                  : driverPhoneNumber
              }
              placeholder={
                !isFocusedDriver && driverPhoneNumber.length === 10 && apiSucessForDriver === 'true'
                  ? ''
                  : 'Phone Number'
              }
              onChange={handlePhoneNumberChange}
              onFocus={handleFocusDriver}
              onBlur={handleBlurDriver}
              error={!!driverPhoneError}
              helperText={driverPhoneError}
              style={{ width: '225px' }}
            />
          </Box>
        </Box>
        {apiSucessForDriver === 'true' && !isFocusedDriver && (
          <>
            {userRole === 'vendor_supervisor' || userRole === 'vendor_company_admin' ? (
              <>
                <Box sx={{ marginLeft: { xs: '-10px', sm: '0px' }, marginTop: '5px' }}>                
                  <p style={{ fontSize: '17px' }}>Warehouse</p>
                </Box>
                <Box sx={{ marginLeft: { xs: '112px', sm: '200px' }, marginTop: '-23px' }}>
                <FormControl sx={{ width: 225 }}>
            <Select
  labelId="warehouse-multiple-label"
  id="warehouse-multiple"
  multiple
  value={selectedWarehouse.map(wh => wh.id)}
 onChange={handleWarehouseSelectionChange}
  renderValue={(selected) => (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {selected?.map((value: string) => {
        const warehouse = options.find(wh => wh.id === value);
        return warehouse ? (
          <Chip
            key={warehouse.id}
            label={warehouse.label}
            onDelete={(e) => {
              e.stopPropagation();
              const mapping = warehouseId.find(
                wh => wh.warehouse_id.toString() === warehouse.id
              );

              if (mapping) {
                const userWarehouseId = mapping.user_warehouse_id;
                
                deleteUserWarehousemapping(
                  userWarehouseId,
                  (response) => {
                    if (response.status === 200) {
                      toast.success(`Warehouse ${warehouse.label} removed successfully`);
                      setWarehouseData(prev => 
                        prev.filter(wh => wh.id.toString() !== warehouse.id)
                      );
                      setSelectedWarehouse(prev =>
                        prev.filter(wh => wh.id !== warehouse.id)
                      );
                    }
                  },
                  (error) => {
                    toast.error(`Failed to remove warehouse ${warehouse.label}: ${error.message}`);
                  }
                );
              }
            }}
            deleteIcon={
              <CancelIcon 
                onMouseDown={(event) => event.stopPropagation()} 
              />
            }
          />
        ) : null;
      })}
    </Box>
  )}
  error={!!errorWarehouse}
>
  {options.map((option) => (
    <MenuItem key={option.id} value={option.id}>
      {option.label}
    </MenuItem>
  ))}
</Select>
        {errorWarehouse && (
          <p style={{ color: '#d32f2f', fontSize: '0.75rem', margin: '3px 14px 0' }}>
            {errorWarehouse}
          </p>
        )}
      </FormControl>
                </Box>
                <Box sx={{ marginLeft: { xs: '-10px', sm: '0px' }, marginTop: errorWarehouse ? '18px' : '10px' }}>
                  <p style={{ fontSize: '17px' }}>Vendor</p>
                </Box>
                <Box
                  sx={{ marginLeft: { xs: '112px', sm: '200px' }, marginTop: errorWarehouse ? '-19px' : '-28px' }}
                >
                  <Box display="flex" alignItems="center">
                    <TextField
                      variant="outlined"
                      size="small"
                      type="text"
                      name="vendorName"
                      disabled
                      value={vendorName}
                      style={{ width: '225px' }}
                    />
                  </Box>
                </Box>
              </>
            ) : userRole === 'client_supervisor' || userRole === 'client_manager' || userRole === 'client_company_admin' ? (
              <>
                <Box sx={{ marginLeft: { xs: '-10px', sm: '0px' }, marginTop: '5px' }}>                <p style={{ fontSize: '17px' }}>Client Name</p>
                </Box>
                <Box sx={{ marginLeft: { xs: '112px', sm: '200px' }, marginTop: '-25px' }}>
                 <TextField
                 variant="outlined"
                  size="small"
                  type="text"
                  name="clientName"
                  disabled
                  value={clientName}
                  style={{ width: '225px' }} />
                </Box>
                <Box sx={{ marginLeft: { xs: '-10px', sm: '0px' }, marginTop: '5px' }}>
                  <p style={{ fontSize: '17px' }}>Warehouse</p>
                </Box>
                <Box sx={{ marginLeft: { xs: '112px', sm: '200px' }, marginTop: '-25px' }}>
                <FormControl sx={{ width: 225 }}>
            <Select
  labelId="warehouse-multiple-label"
  id="warehouse-multiple"
  multiple
  value={selectedWarehouse.map(wh => wh.id)}
 onChange={handleWarehouseSelectionChange}
  renderValue={(selected) => (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
      {selected.map((value) => {
        const warehouse = options.find(wh => wh.id === value);
        return warehouse ? (
          <Chip
            key={warehouse.id}
            label={warehouse.label}
            onDelete={(e) => {
              e.stopPropagation();
              const mapping = warehouseId.find(
                wh => wh.warehouse_id.toString() === warehouse.id
              );

              if (mapping) {
                const userWarehouseId = mapping.user_warehouse_id;
                
                deleteUserWarehousemapping(
                  userWarehouseId,
                  (response) => {
                    if (response.status === 200) {
                      toast.success(`Warehouse ${warehouse.label} removed successfully`);
                      setWarehouseData(prev => 
                        prev.filter(wh => wh.id.toString() !== warehouse.id)
                      );
                      setSelectedWarehouse(prev =>
                        prev.filter(wh => wh.id !== warehouse.id)
                      );
                    }
                  },
                  (error) => {
                    toast.error(`Failed to remove warehouse ${warehouse.label}: ${error.message}`);
                  }
                );
              }
            }}
            deleteIcon={
              <CancelIcon 
                onMouseDown={(event) => event.stopPropagation()} 
              />
            }
          />
        ) : null;
      })}
    </Box>
  )}
  error={!!errorWarehouse}
>
  {options.map((option) => (
    <MenuItem key={option.id} value={option.id}>
      {option.label}
    </MenuItem>
  ))}
</Select>
        {errorWarehouse && (
          <p style={{ color: '#d32f2f', fontSize: '0.75rem', margin: '3px 14px 0' }}>
            {errorWarehouse}
          </p>
        )}
      </FormControl>
                </Box>
              </>
            ) : (
              <p> Service Not Available </p>
            )}
          </>
        )}
      </DialogContent>
      <DialogActions style={{ display: 'flex', justifyContent: 'center' }}>
      <Button className="custom-button"  disabled={isVehicleInactive} onClick={handleSubmit}>
    {isEditMode ? 'Edit' : 'Add'}
  </Button>
        <Button className="custom-cancel-button" onClick={handleCancel}>Cancel</Button>
        
      </DialogActions>
      {vehicleId !== null && (
          <AddDocumentModal
            isDocumentOpen={isDocumentModalOpen}
            handleClose={handleClose}
            vehicleId={vehicleId}
            onRefreshVehicles={onRefreshVehicles}
          />
        )}
      <AddOwnerModal
        isOpen={isAddOwnerModalOpen}
        handleClose={() => setIsAddOwnerModalOpen(false)}
        phoneNumber={ownerPhoneNumber}
        onAddOwner={handleAddOwner}
      />
      {isOTPModalOpen && (
        <OTPVerificationModal
          isOpen={isOTPModalOpen}
          handleClose={() => setIsOTPModalOpen(false)}
          phoneNumber={driverPhoneNumber}
          handleVerifyOTP={handleVerifyOTP}
        />
      )}

<ConfirmationModal
  isOpen={isConfirmationOpen}
  onClose={() => setIsConfirmationOpen(false)}
  onConfirm={handleConfirmationAction}
/>

    </Dialog>
  );
};

export default AddVehicleModal;